var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGumroad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2036_72345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.183 18.3855C14.9148 18.3855 18.7506 14.7129 18.7506 10.1824C18.7506 5.65194 14.9148 1.97925 10.183 1.97925C5.45116 1.97925 1.61523 5.65194 1.61523 10.1824C1.61523 14.7129 5.45116 18.3855 10.183 18.3855Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.0209C14.617 18.0209 18.3861 14.4443 18.3861 10.0001C18.3861 5.55592 14.617 1.97925 10.0007 1.97925C5.38435 1.97925 1.61523 5.55592 1.61523 10.0001C1.61523 14.4443 5.38435 18.0209 10.0007 18.0209Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9.99992C1.25 5.34116 5.19589 1.6145 10 1.6145C14.8042 1.6145 18.75 5.34116 18.75 9.99992C18.75 14.6587 14.8042 18.3853 10 18.3853C5.19589 18.3853 1.25 14.6587 1.25 9.99992ZM10 2.20254C5.49338 2.20254 1.83725 5.69216 1.83725 9.99992C1.83725 14.3077 5.49338 17.7973 10 17.7973C14.5067 17.7973 18.1628 14.3077 18.1628 9.99992C18.1628 5.69216 14.5067 2.20254 10 2.20254Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00139 14.0105C6.64554 14.0105 5.25977 12.1023 5.25977 9.72862C5.25977 7.26181 6.7841 5.2605 9.6942 5.2605C12.6968 5.2605 13.7129 7.30841 13.7591 8.47191H11.5881C11.542 7.82034 10.9876 6.84296 9.64805 6.84296C8.21613 6.84296 7.29224 8.09961 7.29224 9.63553C7.29224 11.1714 8.21613 12.428 9.64805 12.428C10.9415 12.428 11.4958 11.4041 11.7267 10.3802H9.64805V9.54244H14.0098V13.8243H12.0963V11.1248C11.9576 12.1023 11.3571 14.0105 9.00139 14.0105Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2036_72345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(1.25 1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGumroad);
export default __webpack_public_path__ + "static/media/gumroad.773ffc6eec936810888df03cf6d23e62.svg";
export { ForwardRef as ReactComponent };